import type { AuthenticationService } from './mx-authentication-service';
import type { IRequestConfig, auto, IHttpResponse, IHttpInterceptor } from 'angular';

authorizationInterceptor.$inject = ['$injector'];
export function authorizationInterceptor($injector: auto.IInjectorService): IHttpInterceptor {
	return {
		responseError: async function (response: IHttpResponse<unknown>) {
			const authService: AuthenticationService = $injector.get('mx.shell.AuthService');

			if (response.status === 401 || response.status === 406) {
				await authService.logout();
			}
			return Promise.reject(response);
		},

		request: async function (config: IRequestConfig) {
			const authService: AuthenticationService = $injector.get('mx.shell.AuthService');
			await authService.checkForTokenExpirationAndRefresh();
			const token = await authService.getToken();
			if (token) {
				config.headers ||= {};
				config.headers.Authorization = config.headers.Authorization || `Bearer ${token}`;
			}
			return config;
		},
	};
}
